import React from 'react'
import { StyledTitle } from './App'
import styled from 'styled-components'
import StarRatings from 'react-star-ratings'

const profile1 = require('../assets/images/juliana.jpg')
const profile2 = require('../assets/images/pablo.jpg')
const profile3 = require('../assets/images/martin.jpg')

const Testimonial = () => {
  return (
    <div className='py-5 p-md-5' style={{ backgroundColor: 'white' }}>
      <div className='container d-flex flex-wrap'>
        <div className='col-md-12'>
          <StyledTitle align='center' className='mb-5'>
            TESTIMONIOS
          </StyledTitle>
          <br />
        </div>
        <div className='col-md-4 d-flex flex-wrap align-items-center justify-content-center'>
          <div className='text-center mb-4'>
            <img src={profile1} alt='' className='img-fluid rounded-circle' style={{ width: '30%' }} />
          </div>
          <TextContent>
            Muy buena la atención de la gente de tramita ya son realmente amables y cordiales.
          </TextContent>
          <StarRatings numberOfStars={5} starRatedColor='#30BDBB' rating={4.5} starDimension='20px' />
          <StyledName>Carla Muñoz</StyledName>
        </div>
        <div
          style={{ borderLeft: '1px #30BDBB solid', borderRight: '1px #30BDBB solid', flexDirection: 'column' }}
          className='col-md-4 d-flex flex-wrap align-items-center justify-content-center'>
          <div className='text-center mb-4'>
            <img src={profile2} alt='' className='img-fluid rounded-circle' style={{ width: '30%' }} />
          </div>
          <TextContent>
              La verdad es que no tengo quejas, cargue todo muy fácil y me llego todo por mail a tiempo.
          </TextContent>
          <StarRatings numberOfStars={5} starRatedColor='#30BDBB' rating={4.5} starDimension='20px' />
          <StyledName>Roberto Gimenez</StyledName>
        </div>
        <div className='col-md-4 d-flex flex-wrap align-items-center justify-content-center' style={{flexDirection: 'column'}}>
          <div className='text-center mb-4'>
            <img src={profile3} alt='' className='img-fluid rounded-circle' style={{ width: '30%' }} />
          </div>
          <TextContent>
            Al comienzo tenía mis dudas sobre ellos, pero respondieron muy bien, en ningún momento dejaron de comunicarse hasta finalizar mi trámite.
          </TextContent>
          <StarRatings numberOfStars={5} starRatedColor='#30BDBB' rating={5} starDimension='20px' />
          <StyledName>Federico Kozinsky</StyledName>
        </div>
      </div>
    </div>
  )
}

const TextContent = styled.p`
  font-family: Montserrat!important;  
  font-weight: 500;
  text-align: justify;
  font-size: 15px;
  padding-left: 80px;
  padding-right: 80px;
  min-height: 150px;
`

const StyledName = styled.p`
  font-family: Montserrat!important;
  font-weight: 700;
  text-align: center;
  color: black;
  font-size: 18px;
  margin-top: 18px;
  padding-left: 80px;
  padding-right: 80px;
`

export default Testimonial
